/**
 * @fileoverview Hook UI Layer para CustomerFunnelsMC: opciones de temperatura y traducciones.
 * @module useCustomerFunnelsUI
 * @category Hook - UI Layer
 * @since 3.1.0
 * @version 3.1.1
 */
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

/**
 * Hook UI Layer para CustomerFunnelsMC: opciones de temperatura y traducciones.
 *
 * @returns {Object} { t, options }
 * @example
 * const { t, options } = useCustomerFunnelsUI();
 */
export default function useCustomerFunnelsUI() {
  const { t } = useTranslation('InboxMC');
  const tempClasses = useMemo(() => ({
    cold: 'tw-text-blue-400 tw-bg-blue-50',
    warm: 'tw-text-yellow-500 tw-bg-yellow-50',
    hot: 'tw-text-red-400 tw-bg-red-50'
  }), []);

  const options = useMemo(() =>
    Object.entries(tempClasses).map(([key, value]) => ({
      label: t(`Funnels:deal.temperature.${key}`),
      value: key,
      icon: { iconName: 'thermometer-outline', size: 'base', className: value }
    })), [t, tempClasses]);

  return { t, options };
}
